export default __webpack_public_path__ + "static/media/tk.f5fe039b.svg";